import { type ReactNode } from 'react';
import { Icon, type IconName } from './Icon.js';
import { cx } from './utils.js';

export function Card(props: {
  title?: string | undefined;
  description?: string | undefined;
  icon?: IconName | undefined;
  actions?: ReactNode;
  children: ReactNode;
  className?: string | undefined;
  flush?: boolean | undefined;
}) {
  return (
    <section
      className={cx(
        'flex min-h-0 flex-col overflow-hidden rounded-[var(--admin-radius,0.625rem)] border border-[color:var(--admin-border,#d8dee6)] bg-[color:var(--admin-surface,#fff)] shadow-[var(--admin-shadow-sm)] dark:border-slate-700 dark:bg-slate-900',
        props.className,
      )}
    >
      {props.title ? (
        <header className="flex flex-wrap items-start justify-between gap-3 border-b border-[color:var(--admin-border,#d8dee6)] px-5 py-3.5 dark:border-slate-800">
          <div className="flex min-w-0 flex-1 basis-48 items-start gap-3">
            {props.icon ? (
              <span className="grid size-8 shrink-0 place-items-center rounded-[var(--admin-radius-sm)] border border-[color:var(--admin-border)] bg-[color:var(--admin-paper,#f4f6f8)] text-[color:var(--admin-accent,#2563EB)] dark:bg-slate-950">
                <Icon name={props.icon} className="size-3.5" />
              </span>
            ) : null}
            <div className="min-w-0">
              <h3 className="admin-display text-sm font-semibold text-slate-900 dark:text-slate-100">
                {props.title}
              </h3>
              {props.description ? (
                <p className="mt-0.5 text-sm leading-relaxed text-slate-500 dark:text-slate-400">
                  {props.description}
                </p>
              ) : null}
            </div>
          </div>
          {props.actions}
        </header>
      ) : null}
      <div className={cx('flex min-h-0 flex-1 flex-col', props.flush ? undefined : 'p-5')}>
        {props.children}
      </div>
    </section>
  );
}
